import WinCelebration from '@/components/ui/Lottie/WinCelebration';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import {
  showCelebrationAtom,
  CelebrationInfoAtom,
  CelebrationType,
  CelebrationInfo,
} from './state';
import { useRouter } from 'next/router';
import { defaultCoinConfig } from '@/components/ui/Lottie/WinCelebration/CoinCanvas';

export const useCelebration = () => {
  const showCelebration = useSetAtom(showCelebrationAtom);
  const setCelebrationInfo = useSetAtom(CelebrationInfoAtom);

  const { route } = useRouter();

  const gameType = useMemo(() => {
    if (route.includes('crash')) {
      return CelebrationType.Crash;
    } else if (route.includes('rush')) {
      return CelebrationType.Rush;
    } else {
      console.error('error type', route);
      return CelebrationType.Crash;
    }
  }, [route]);

  const celebrate = (info: CelebrationInfo) => {
    showCelebration(true);
    setCelebrationInfo({
      ...info,
      type: gameType,
    });
  };
  return {
    celebrate,
  };
};

const Celebration: React.FC = () => {
  const ANIMATION_DURATION = 6000;

  const celebrationRef = useRef<HTMLDivElement>(null);
  const [showWinCelebration, setShowWinCelebration] =
    useAtom(showCelebrationAtom);
  const [celebrationInfo, setCelebrationInfo] = useAtom(CelebrationInfoAtom);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (showWinCelebration) {
      setLoaded(true);
      //  reset state after animation
      setTimeout(() => {
        setShowWinCelebration(false);
        setCelebrationInfo((info) => ({
          ...info,
          multiplier: 0,
          profit: '0',
        }));
      }, ANIMATION_DURATION);
    }
  }, [showWinCelebration]);

  const coinConfig = useMemo(() => {
    if (celebrationInfo && celebrationInfo.coinCount) {
      const countPercent = celebrationInfo.coinCount;
      return {
        ...defaultCoinConfig,
        countPercent: countPercent ? countPercent : 0,
      };
    } else {
      return defaultCoinConfig;
    }
  }, [celebrationInfo]);

  return (
    <div ref={celebrationRef} style={{ opacity: loaded ? 1 : 0 }}>
      {showWinCelebration && (
        <WinCelebration
          show={showWinCelebration}
          info={celebrationInfo}
          coinConfig={coinConfig}
        />
      )}
    </div>
  );
};

export default Celebration;
